import React, { useState, createContext, useContext } from 'react';
interface ConsultationContextType {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}
const ConsultationContext = createContext<ConsultationContextType>({
  isModalOpen: false,
  openModal: () => {},
  closeModal: () => {}
});
export function useConsultation() {
  return useContext(ConsultationContext);
}
export function ConsultationProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <ConsultationContext.Provider value={{
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal: () => setIsModalOpen(false)
  }} data-id="element-42">
      {children}
    </ConsultationContext.Provider>;
}